<template>
  <div class="hiring-banner">
    <div class="banner-content">
      <div class="banner-text">
        <div class="text-wrapper">
          <div class="text-content">
            <span class="text-item"
              >🚀 We're Hiring Interns! Join our dynamic team and kickstart your
              career with hands-on experience</span
            >
            <span class="text-item"
              >🚀 We're Hiring Interns! Join our dynamic team and kickstart your
              career with hands-on experience</span
            >
            <span class="text-item"
              >🚀 We're Hiring Interns! Join our dynamic team and kickstart your
              career with hands-on experience</span
            >
          </div>
        </div>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfoEjf3neXXGL7fE5l2btXtKD2NBZc09kzzkztTT1JPLdyVjQ/viewform"
          class="apply-btn-inline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Apply Now
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HiringBanner",
};
</script>

<style scoped>
.hiring-banner {
  background: linear-gradient(135deg, #f47726 0%, #ff6b35 100%);
  color: white;
  padding: 12px 0;
  text-align: left;
  position: relative;
  overflow: hidden;
  margin-top: 80px;
}

.hiring-banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="20" cy="20" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="80" cy="40" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="40" cy="80" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
  pointer-events: none;
}

.banner-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.banner-text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 20px;
}

.text-wrapper {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.text-content {
  display: flex;
  font-size: 18px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
}

.text-item {
  display: inline-block;
  padding-right: 100px;
}

.apply-btn-inline {
  background: white;
  color: #f47726;
  padding: 12px 24px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 700;
  font-size: 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  white-space: nowrap;
  flex-shrink: 0;
}

.apply-btn-inline:hover {
  background: transparent;
  color: white;
  border-color: white;
}

/* Desktop - Static banner */
@media (min-width: 769px) {
  .text-content {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .text-item:not(:first-child) {
    display: none !important;
  }

  .text-item:first-child {
    padding-right: 0;
  }
}

/* Mobile - Moving banner with static button */
@media (max-width: 768px) {
  .hiring-banner {
    margin-top: 60px;
    padding: 16px 0;
  }

  .banner-text {
    position: relative;
    height: 50px;
    align-items: center;
  }

  .text-wrapper {
    position: absolute;
    left: 0;
    right: 140px;
    overflow: hidden;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .text-content {
    animation: scroll-mobile 15s linear infinite;
    font-size: 16px;
  }

  .apply-btn-inline {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    padding: 10px 20px;
    z-index: 2;
  }

  .hiring-banner:hover .text-content {
    animation-play-state: paused;
  }
}

@keyframes scroll-mobile {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-33.33%);
  }
}

@media (max-width: 480px) {
  .hiring-banner {
    padding: 12px 0;
    margin-top: 60px;
  }

  .banner-text {
    height: 45px;
  }

  .text-wrapper {
    right: 110px;
  }

  .text-content {
    font-size: 16px;
    animation-duration: 12s;
  }

  .apply-btn-inline {
    font-size: 13px;
    padding: 8px 16px;
  }
}
</style>
